import React, { Component } from 'react'

import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline, Link
} from "mdbreact";

import {  MDBContainer, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip } from 'antd';
import { URL } from '../api';
import logos from '../Pages/img/logokpru.png'



export default class Header extends Component {
 
 
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      nameuser: '',
      admin_type: '',
      Username: '',
      collapse: false,
      isWideEnough: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }
  
    

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }



    componentDidMount() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') !== "") {
          this.setState({ nameuser: localStorage.getItem('nameuser') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
    
            this.setState({ admin_type: 'public' })
        }
      }


      logout() {
      //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
    
        setTimeout(() => {
          window.location.href = 'https://e-student.kpru.ac.th/tess'
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }



    render() {



        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Timetable"><MDBIcon icon="file-alt" /> จัดการตารางเรียน</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem  >
              <MDBDropdown   >
                <MDBDropdownToggle  nav caret>
                  {/* <span className="mr-2"><MDBIcon icon="book" /> จัดการตารางเรียน</span> */}
                  <div className="d-none d-md-inline "><MDBIcon icon="book" /> จัดการตารางเรียน</div>
                </MDBDropdownToggle>
                <MDBDropdownMenu  class="dropdown-content">
                <Link to="/Timetable"  > <MDBDropdownItem className='gradient2 text-white' ><MDBIcon icon="file-alt" /> จัดการตารางเรียนทั้งหมด ค้นจากอาจารย์</MDBDropdownItem></Link>
                <Link to="/Timetablebygruop" > <MDBDropdownItem className='gradient2 text-white'><MDBIcon icon="file-alt" /> จัดการตารางเรียนทั้งหมด ค้นจากหมู่เรียน</MDBDropdownItem></Link>
                <Link to="/Timetabletype2">  <MDBDropdownItem className='gradient2 text-white'><MDBIcon icon="city" /> จัดการตารางเรียน กศ.บป ค้นจากอาจารย์</MDBDropdownItem></Link>
                
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
           

            {/* <MDBNavItem >
                 <MDBNavLink to="/Classroom"><MDBIcon far icon="chart-bar" />จัดการห้องเรียน</MDBNavLink>
            </MDBNavItem> */}
            {/* <MDBNavItem >
                 <MDBNavLink to="/superadminstatus"><MDBIcon icon="home" /> สถานะบทความ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminlistregister"><MDBIcon icon="home" /> ข้อมูลผู้ลงทะเบียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminaddress"><MDBIcon icon="home" /> ที่อยู่</MDBNavLink>
            </MDBNavItem> */}
            
            {/* https://git.kpru.ac.th/FrontEnd_Checkfinish/index/showstudentgropu/6413201 */}
          
          
            {/* <MDBNavItem >
                 <MDBNavLink to="/Timetable"><MDBIcon far icon="chart-bar" />ตั้งค่า</MDBNavLink>
            </MDBNavItem> */}

            
             <MDBNavItem >
                 <MDBNavLink to="/Teach"><MDBIcon icon="sim-card" /> ตารางสอน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Learn"><MDBIcon icon="table" /> ตารางเรียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Searchroom"><MDBIcon icon="search-location" /> ค้นหาห้อง</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Teachpay"><MDBIcon icon="dollar-sign" /> จัดการเบิกค่าตอบแทนผู้สอน</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Reporttess"><MDBIcon icon="book" /> รายงาน</MDBNavLink>
            </MDBNavItem> */}

            <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="book" /> รายงาน</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu  class="dropdown-content" >
                <Link to="/Reporttess" > <MDBDropdownItem className='bgcolormenu1 text-white' ><MDBIcon icon="door-closed" /> รายงานแบบเล่ม</MDBDropdownItem></Link>
                <Link to="/Reporttess2">  <MDBDropdownItem className='bgcolormenu2 text-white' ><MDBIcon icon="city" /> รายงานแบบรายคน</MDBDropdownItem></Link>
                <Link to="/Reporttesscheckall">  <MDBDropdownItem className='bgcolormenu3 text-white'  ><MDBIcon icon="id-card-alt" /> รายงานตรวจทั้งหมด ภาค ปกติ กำแพง</MDBDropdownItem></Link>
                <Link to="/Reporttesscheckall5">  <MDBDropdownItem className='bgcolormenu4 text-white' ><MDBIcon icon="id-card-alt" /> รายงานตรวจทั้งหมด ภาค ปกติ แม่สอด</MDBDropdownItem></Link>
                <Link to="/Reporttesscheckall2">  <MDBDropdownItem className='bgcolormenu5 text-white'><MDBIcon icon="store" /> รายงานตรวจทั้งหมด ภาค กศ.บป กำแพง</MDBDropdownItem></Link>
                <Link to="/Reporttesscheckall3">  <MDBDropdownItem className='bgcolormenu6 text-white'><MDBIcon icon="store" /> รายงานตรวจทั้งหมด ภาค กศ.บป แม่สอด</MDBDropdownItem></Link>
                <Link to="/Reporttesstotal">  <MDBDropdownItem className='bgcolormenu7 text-white'><MDBIcon icon="chart-pie" /> รายงานสรุปการจัดตาราง</MDBDropdownItem></Link>

                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            
              <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="cog" /> จัดการรายชื่อประชุม</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu class="dropdown-content" >
                <Link to="/Listname" > <MDBDropdownItem className='bgcolormenu2 text-white' >รายชื่อ(สภามหาวิทยาลัย)</MDBDropdownItem></Link>
                <Link to="/Listname2">  <MDBDropdownItem className='bgcolormenu3 text-white'>รายชื่อ(กรรมการบริหาร ก.บ)</MDBDropdownItem></Link>
                <Link to="/Listname3">  <MDBDropdownItem className='bgcolormenu4 text-white'>รายชื่อ(กรรมการบริหาร สภาวิชาการ)</MDBDropdownItem></Link>
                <Link to="/Listname4">  <MDBDropdownItem className='bgcolormenu5 text-white'>รายชื่อ(อาจารย์ติดภารกิจ)</MDBDropdownItem></Link>
                  {/* <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem> */}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

            <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="cog" /> ตั้งค่าห้องและอาคาร</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu class="dropdown-content" >
                <Link to="/Buildingreport" > <MDBDropdownItem className='bgcolormenu2 text-white'><MDBIcon icon="door-closed" /> การใช้อาคาร</MDBDropdownItem></Link>
                <Link to="/Classroom" > <MDBDropdownItem className='bgcolormenu3 text-white'><MDBIcon icon="door-closed" /> จัดการห้องเรียน</MDBDropdownItem></Link>
                <Link to="/Building">  <MDBDropdownItem className='bgcolormenu4 text-white'><MDBIcon icon="city" /> จัดการอาคารเรียน</MDBDropdownItem></Link>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>


             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-in-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

        let adminfaculty
        adminfaculty = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/adminfaculty"><MDBIcon icon="home" /> เมนู1</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/adminfacultyproportion"><MDBIcon icon="home" /> เมนู2</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let expert
        expert = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink>
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    


        let publics
        publics = (
          <>
            <MDBNavItem  >
              <MDBNavLink to="/">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
           
            {/* <MDBNavItem  >
              <MDBNavLink to="/main/LoginPages">  เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem> */}
          </>
        )

        return (
            <>
            
                <MDBNavbar color="cyan darken-4" dark expand="md" >
                    <MDBNavbarBrand>
                       <strong className="white-text"><img src={logos} className="rounded mx-auto " alt="aligment" width='30px' /> KPRU-TESS</strong>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3"  isOpen={this.state.isOpen}  navbar>
                        <MDBNavbarNav left>

                            {/* <MDBNavItem >
                                <MDBNavLink to="/"><MDBIcon icon="home" /> Home</MDBNavLink>
                            </MDBNavItem> */}
                      {/* { localStorage.getItem('name') == null ? <>
                      {publics}
                     {window.location.href = '/tess'} 
                      </>:<>
                                     
                      </>}
                                                 */}
                                      {this.state.admin_type === '2' ? <>
                                      {superadmin}
                                                      
                                      </> : null}

                                      {this.state.admin_type === '3' ? <>
                                      {expert}
                                      </> : null}

                                      {this.state.admin_type === '4' ? <>
                                      {adminfaculty}
                  

                                      </> : null}  
                              

                        </MDBNavbarNav>
                        <MDBNavbarNav right>
                            <MDBNavItem>
                                {/* <MDBFormInline waves>
                                    <div className="md-form my-0">
                                        <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
                                    </div>
                                </MDBFormInline> */}
                            </MDBNavItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBNavbar>


                

            </>
        )
    }
}

